import { createAsyncThunk } from "@reduxjs/toolkit";
import { type DeliveryZone } from "../../../domain/entities/referral-backoffice";
import { type ReferralsBackofficeDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

/**
 * The zone filter's options.
 *
 * They cannot come from the summary rows: those carry a zone *name* and never
 * one at all when grouped by supervisor, while the API validates `zone_id` as a
 * uuid. Read once per screen — the catalogue does not change while it is open.
 */
export const listZones = createAsyncThunk<
  DeliveryZone[],
  void,
  { dispatch: ReferralsBackofficeDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LIST_ZONES, async (_, { extra }) => {
  return await extra.referralsBackofficeRepo.listZones();
});
